module.exports = __webpack_public_path__ + "static/media/calendar_icon.808c238c.png";